import { Rewards } from '@arrived/models';

import { rewardsApi } from '../api';

export const postPromotionRedemptionPreview = async (promotionRedemptionBody: Rewards.PromotionRedemptionRequest) => {
  const response = await rewardsApi.post<Rewards.PromotionRedemption>(
    `/reward-redemptions-preview?includeVouchers=true&includePromotion=true`,
    promotionRedemptionBody
  );
  return response.data;
};

export const postRewardsRedemptionPreview = async (rewardsRedemptionBody: Rewards.RewardRedemptionRequest) => {
  const response = await rewardsApi.post<Rewards.RewardRedemption>(
    `/reward-redemptions-preview?includeVouchers=true&includePromotion=true`,
    rewardsRedemptionBody
  );
  return response.data;
};
